/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PhasesInputs */

const vi_nav_phases = /** @type {(inputs: Nav_PhasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giai đoạn`)
};

/**

* @param {Nav_PhasesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_phases = /** @type {((inputs?: Nav_PhasesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PhasesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_phases(inputs)
});